module.exports = __webpack_public_path__ + "static/media/gw.7bfe77f5.svg";